import axios from "@/services/axios";

/** ------------------ Course APIs ------------------ */
export const fetchAllCourses = async (userId) => {
  const response = await axios.get(`/course/all/${userId}`);
  return response.data;
};

export const fetchCourseById = async (id) => {
  const response = await axios.get(`/course/${id}`);
  return response.data;
};

export const createCourse = async (courseData) => {
  const response = await axios.post("/course/new", courseData);
  return response.data;
};

export const updateCourse = async (id, updatedData) => {
  const response = await axios.patch(`/course/${id}`, updatedData);
  return response.data;
};

export const deleteCourse = async (userId, courseId) => {
  const response = await axios.delete(`/course/${userId}/${courseId}`);
  return response.data;
};

export const addCourseMembers = async (courseId, userId) => {
  const response = await axios.patch(`/course/members/${courseId}`, { userID: userId });
  return response.data;
};

export const updateUserCourse = async (userId, courseId) => {
  const response = await axios.patch(`/user/${userId}/${courseId}`);
  return response.data;
};

export const getKeynotes = async (courseId, title, language) => {
  const response = await axios.patch(`/course/keynotes/${courseId}/${title}`, {
    language: language,
  });
  return response.data;
};

export const trainCourse = async (courseId, formData) => {
  const response = await axios.post(`/course/train/${courseId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

/** ------------------ Flashcards APIs ------------------ */
export const fetchFlashcards = async (courseId) => {
  const response = await axios.get(`/practice/flash/${courseId}`);
  return response.data;
};

export const createFlashcard = async (courseId, { requestData, config }) => {
  const response = await axios.post(`/practice/flash/${courseId}`, requestData, config);
  return response.data;
};

/** ------------------ Quizzes APIs ------------------ */
export const fetchQuizzes = async (courseId) => {
  const response = await axios.get(`/courses/${courseId}/quizzes`);
  return response.data;
};

export const createQuiz = async (courseId, quizData) => {
  const response = await axios.post(`/courses/${courseId}/quizzes`, quizData);
  return response.data;
};

/** ------------------ Roadmap / Topics APIs ------------------ */

export const addTopicToUnit = async (courseId, unitId, topicData) => {
  const response = await axios.post(`/course/${courseId}/units/${unitId}/topics`, topicData);
  return response.data;
};

export const deleteTopicFromUnit = async (courseId, unitId, topicId) => {
  const response = await axios.delete(`/course/${courseId}/units/${unitId}/topics/${topicId}`);
  return response.data;
};

export const deleteTopic = async (courseId, topic) => {
  const response = await axios.delete(`/course/topic/${courseId}/${encodeURIComponent(topic)}`);
  return response.data;
};

/** ------------------community ----------------------- **/

export const getCommunityMessages = async (communityId) => {
  const { data } = await axios.get(`/chat/${communityId}`);
  return data.data || [];
};

export const sendCommunityMessage = async (communityId, messageData) => {
  const { data } = await axios.post(`/chat/${communityId}`, messageData);
  return data;
};